import React, { useState } from 'react';

const DEFAULT_STEPS = [
  {
    id: 'service',
    name: 'Select Service',
    description: 'Choose your preferred treatment',
    required: true,
    enabled: true,
    icon: '🏥'
  },
  {
    id: 'practitioner',
    name: 'Choose Practitioner',
    description: 'Select your therapist',
    required: true,
    enabled: true,
    icon: '👨‍⚕️'
  },
  {
    id: 'location',
    name: 'Select Location',
    description: 'Choose clinic location',
    required: true,
    enabled: true,
    icon: '📍'
  },
  {
    id: 'date',
    name: 'Pick Date',
    description: 'Pick an available date',
    required: true,
    enabled: true,
    icon: '📅'
  },
  {
    id: 'time',
    name: 'Choose Time',
    description: 'Select your preferred time',
    required: true,
    enabled: true,
    icon: '🕐'
  },
  {
    id: 'details',
    name: 'Your Details',
    description: 'Please provide your information',
    required: true,
    enabled: true,
    icon: '📝'
  },
  {
    id: 'confirm',
    name: 'Confirm Booking',
    description: 'Review and confirm your booking',
    required: true,
    enabled: true,
    icon: '✅'
  }
];

const WidgetStepReorder = ({ widget, onSave, onCancel, showNotification }) => {
  const [steps, setSteps] = useState(DEFAULT_STEPS);
  const [hasChanges, setHasChanges] = useState(false);
  const [draggedIndex, setDraggedIndex] = useState(null);


  const handleDragStart = (e, index) => {
    setDraggedIndex(index);
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/plain', index);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDrop = (e, targetIndex) => {
    e.preventDefault();

    if (draggedIndex === null || draggedIndex === targetIndex) {
      setDraggedIndex(null);
      return;
    }

    const newSteps = [...steps];
    const draggedStep = newSteps[draggedIndex];

    // Remove dragged item
    newSteps.splice(draggedIndex, 1);

    // Insert at new position
    newSteps.splice(targetIndex, 0, draggedStep);

    setSteps(newSteps);
    setDraggedIndex(null);
    setHasChanges(true);

  };

  const handleDragEnd = () => {
    setDraggedIndex(null);
  };

  const handleToggleStep = (stepId) => {
    setSteps(prev => prev.map(step =>
      step.id === stepId
        ? { ...step, enabled: !step.enabled }
        : step
    ));
    setHasChanges(true);
  };

  return (
    <div style={{
      padding: '20px',
      background: '#fff',
      maxHeight: '80vh',
      display: 'flex',
      flexDirection: 'column'
    }}>
      {/* HEADER */}
      <div style={{
        marginBottom: '20px'
      }}>
        <p style={{margin: '0', fontSize: '14px', color: '#6b7280'}}>
          Drag to reorder • Toggle to enable/disable • {steps.filter(s => s.enabled).length} of {steps.length} steps enabled
        </p>
      </div>

      {/* MAIN CONTENT - SCROLLABLE */}
      <div style={{
        flex: 1,
        overflowY: 'auto',
        background: '#f9f9f9',
        border: '2px solid #4caf50',
        borderRadius: '8px',
        padding: '20px'
      }}>

        {/* COMPACT STEP CARDS */}
        {steps.map((step, index) => (
          <div
            key={step.id}
            draggable="true"
            onDragStart={(e) => handleDragStart(e, index)}
            onDragOver={handleDragOver}
            onDrop={(e) => handleDrop(e, index)}
            onDragEnd={handleDragEnd}
            style={{
              background: draggedIndex === index ? '#e3f2fd' : (step.enabled ? 'white' : '#f3f4f6'),
              border: draggedIndex === index ? '2px solid #1976d2' : (step.enabled ? '1px solid #ddd' : '1px solid #d1d5db'),
              borderRadius: '6px',
              padding: '10px 15px',
              marginBottom: '8px',
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              cursor: 'move',
              transition: 'all 0.2s ease',
              opacity: draggedIndex === index ? 0.7 : (step.enabled ? 1 : 0.6)
            }}
          >
            {/* DRAG HANDLE */}
            <div style={{
              color: '#9ca3af',
              fontSize: '16px',
              cursor: 'grab',
              padding: '2px'
            }}>
              ⋮⋮
            </div>

            {/* STEP NUMBER */}
            <div style={{
              background: '#0e73e4',
              color: 'white',
              borderRadius: '50%',
              width: '24px',
              height: '24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '12px',
              fontWeight: 'bold',
              flexShrink: 0
            }}>
              {index + 1}
            </div>

            {/* STEP NAME */}
            <div style={{
              flex: 1,
              fontSize: '14px',
              fontWeight: '500',
              color: step.enabled ? '#374151' : '#9ca3af',
              textDecoration: step.enabled ? 'none' : 'line-through'
            }}>
              {step.name}
            </div>

            {/* TOGGLE SWITCH */}
            <label style={{
              position: 'relative',
              display: 'inline-block',
              width: '44px',
              height: '24px',
              cursor: 'pointer'
            }}>
              <input
                type="checkbox"
                checked={step.enabled}
                onChange={() => handleToggleStep(step.id)}
                style={{
                  opacity: 0,
                  width: 0,
                  height: 0
                }}
              />
              <span style={{
                position: 'absolute',
                cursor: 'pointer',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: step.enabled ? '#10b981' : '#d1d5db',
                transition: '0.2s',
                borderRadius: '24px'
              }}>
                <span style={{
                  position: 'absolute',
                  content: '',
                  height: '18px',
                  width: '18px',
                  left: step.enabled ? '23px' : '3px',
                  bottom: '3px',
                  backgroundColor: 'white',
                  transition: '0.2s',
                  borderRadius: '50%',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                }} />
              </span>
            </label>
          </div>
        ))}

      </div>

      {/* ACTION BUTTONS - FIXED BOTTOM */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '20px 0 0 0',
        borderTop: '2px solid #ddd',
        marginTop: '20px'
      }}>
        <div>
          {hasChanges && (
            <span style={{color: '#f59e0b', fontWeight: '500'}}>
              ⚠️ You have unsaved changes
            </span>
          )}
        </div>
        <div style={{display: 'flex', gap: '15px'}}>
          <button
            onClick={onCancel}
            style={{
              padding: '12px 24px',
              background: '#6b7280',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            Cancel
          </button>
          <button
            onClick={() => {
              if (onSave) {
                onSave(widget.id, { steps });
              }
            }}
            disabled={!hasChanges}
            style={{
              padding: '12px 24px',
              background: hasChanges ? '#0e73e4' : '#d1d5db',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: hasChanges ? 'pointer' : 'not-allowed',
              fontSize: '14px'
            }}
          >
            Save Configuration
          </button>
        </div>
      </div>
    </div>
  );
};

export default WidgetStepReorder;